module.exports = __webpack_public_path__ + "assets/b8753ccaad3772fa541523aedd8bdc17.woff";